@import '../../assets/styles/theme';

tspan {
  font-size: 8px !important;
}
body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  overflow-y: hidden;
}

.root {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: white;
}
.container {
  width: 100%;
  height: 100%;
}
.logo {
  color: $text;
  font-size: 36px;
  margin-left: 15px;
}
.links {
  width: 100%;
  height: 40px;
  padding: 0 10px;
}
.link {
  margin: 0px;
  height: 42px;
  width: 95%;
  padding-left: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 18px;
  color: black;
  text-decoration: none;
  border: 1px solid transparent;
  border-radius: 10px;
  &:hover {
    cursor: pointer;
    color: $orange-500;
  }
}
.activeLink {
  color: $orange-500;
  border-color: $border;
}
.sidebar {
  width: 180px;
  flex: 0 0 auto;
  color: $orange-500;
  background-color: #f3f4f6;
  z-index: 1;
  border-right: 1px solid #e5e5e5;
}
.content {
  height: 100%;
  flex: 1 1 auto;
  position: relative;
}
.appContainer {
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  background-color: white;
}

.linkIcon {
  width: 25px !important;
  margin-right: 10px;
}
.logoImage {
  height: 41px;
  width: 146px;
  background-size: cover;
  background-repeat: no-repeat;
  margin-bottom: 50px;
  margin-top: 15px;
}
.header {
  align-self: center;
  max-width: 850px;
  width: 100%;
  padding: 10px;
}
.customerLogo {
  height: 40px;
  width: 400px;
  max-width: 144px;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  margin-bottom: 15px;
}
.customerContent {
  align-self: center;
  padding: 10px;
  width: 100%;
  max-width: 850px;
}
.customerTab {
  color: $meta;
  text-decoration: none;
  font-weight: 200;
  font-size: 18px;
  padding: 5px;
  margin: 0 5px;
  border-bottom: 1px solid transparent;
  transition: 0.2s linear all;
  &:hover {
    border-bottom: 1px solid $secondary;
  }
}
.activeTab {
  color: $orange-500;
  border-bottom: 1px solid $border;
}
.ddl {
  margin-top: 10px;
  min-width: 200px;
}
